__turbopack_context__.v({
  "cta": "styles-module__5Gcy3W__cta",
  "illustration": "styles-module__5Gcy3W__illustration",
  "title": "styles-module__5Gcy3W__title",
  "wrapper": "styles-module__5Gcy3W__wrapper",
});
